import { render, staticRenderFns } from "./AssignmentSwiper.vue?vue&type=template&id=f4ef8ecc"
import script from "./AssignmentSwiper.vue?vue&type=script&lang=js"
export * from "./AssignmentSwiper.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSwiper.vue?vue&type=style&index=0&id=f4ef8ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports